import { getFormResponses, removeFormResponseFromDb } from "@/helpers/server-actions/users-collection";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


interface FormResponsesState {
    responses: Record<string, any>[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: FormResponsesState = {
    responses: [],
    status: 'idle',
}



// create async thunk to fetch form responses
export const fetchFormResponses = createAsyncThunk(
  'formResponses/fetchFormResponses',
  async (userId: string) => {
    const response = await getFormResponses(userId);
    return response;
  }
);

// remove form response
export const removeFormResponse = createAsyncThunk(
  'formResponses/removeFormResponse',
  async ({ userId, formId }: { userId: string, formId: string }) => {
        await removeFormResponseFromDb(userId, formId);
        return formId;
  }
);


const formResponsesSlice = createSlice({
    name:'formResponses',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(fetchFormResponses.pending, (state, action) => {
            state.status = 'loading';
        });

        builder.addCase(fetchFormResponses.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.responses = action.payload;
        });

        builder.addCase(fetchFormResponses.rejected, (state, action) => {
            state.status = 'failed';
        });

        builder.addCase(removeFormResponse.fulfilled, (state, action) => {
            state.responses = state.responses.filter((response) => response.id !== action.payload);
        });

    }

})

export default formResponsesSlice.reducer;

